import { FrontTable } from '@/lib';
import { DistributionChannel } from '@/models/distributionChannels';
import { CampaignResponse } from '@/services/endpoints/campaigns/types';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getConnectedDestinationsTableColumns } from './helpers';

type ConnectedDestinationsTableProps = {
  campaign: CampaignResponse | undefined;
  connectedDestinations: DistributionChannel[];
  isLoading: boolean;
};

export const ConnectedDestinationsTable: FC<ConnectedDestinationsTableProps> = ({ campaign, connectedDestinations, isLoading }) => {
  const { t } = useTranslation();

  const columns = useMemo(() => getConnectedDestinationsTableColumns(t), [t]);

  const tableData = useMemo(
    () =>
      connectedDestinations
        ?.filter((destination) => campaign.destinationTypes?.includes(destination.integrationType))
        .map((destinations) => ({ ...destinations, campaignAudienceId: campaign.audienceId })),
    [connectedDestinations, campaign]
  );

  return <FrontTable isLoading={isLoading} innerWrapperClassName='pb-0 ' tableData={tableData} columns={columns} />;
};
